import { render, staticRenderFns } from "./application_home.vue?vue&type=template&id=56bf738e"
import script from "./application_home.vue?vue&type=script&lang=js"
export * from "./application_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports